/* jshint esversion: 6 */
/* jshint ignore:start */
import openbox from "../Images/open-box.png";
import returnimg from "../Images/return.png";
import time from "../Images/time-24.png";
import mastercard from "../Images/master-card.png";
import logog from '../Images/logowithname.png';
import facebook from '../Images/facebook.png';
import instagram from '../Images/instagram.png';
import twitter from '../Images/twitter.png';
import youtube from '../Images/youtube.png';
import symbol from '../Images/symbol.png';
import visa from '../Images/visa.png';
import paypal from '../Images/paypal.png';
import amex from '../Images/amex.png';
import card from '../Images/card.png';
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useContext, useState } from "react";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Whatapps from "../Images/whatsapp-icon.png";
import istart from "../Images/istart.png";
import iso from "../Images/iso1.png";
import dnb from "../Images/dandb.png";

const Footer = () => {

    const { t } = useTranslation();

    const { BaseUrl, setIsLoginShow } = useContext(MyContext);
    const [pageList, setPageList] = useState([]);

    const Navigate = useNavigate();

    useEffect(() => {
        axios.post(`${BaseUrl}/user_api/u_pagelist.php`)
            .then((res) => {
                setPageList(res.data.pagelist);
            })
            .catch((error) => {
                console.error("u_pagelist", error);
            });
    }, []);

    const HandleNavigate = (path) => {
        Navigate(path);
    };

    return (
        <div className="md:pb-0 pb-[5rem]">
            <div className="width_container">
                <div className="footer">

                    {/* <div className="section_1">
                        <div className="flex_box">
                            <img alt="open-box" src={openbox}></img>
                            <div className="">
                                <h4 className="font-bold">{t("Instant Ticket Delivery")}</h4>
                                <p style={{ fontSize: "14px" }}>{t("Get your event tickets delivered instantly via email or SMS—fast, free, and hassle-free!")}</p>
                            </div>
                        </div>
                        <div className="flex_box">
                            <img alt="open-box" src={returnimg}></img>
                            <div className="">
                                <h4 className="font-bold">{t("Easy Cancellations")}</h4>
                                <p style={{ fontSize: "14px" }}>{t("Change of plans? Cancel or reschedule your booking within 15 days with flexible options.")}</p>
                            </div>
                        </div>
                        <div className="flex_box">
                            <img alt="open-box" src={time}></img>
                            <div className="">
                                <h4 className="font-bold">{t("24/7 Customer Support")}</h4>
                                <p style={{ fontSize: "14px" }}>{t("Got questions? Our team is here 24 hours a day, 7 days a week to assist you at every step.")}</p>
                            </div>
                        </div>
                        <div className="flex_box">
                            <img alt="open-box" src={mastercard}></img>
                            <div className="">
                                <h4 className="font-bold">{t("Secure Payment")}</h4>
                                <p style={{ fontSize: "14px" }}>{t("Book your tickets safely using multiple secure payment methods, including credit and debit cards.")}</p>
                            </div>
                        </div>
                    </div> */}

                    <div style={{ marginTop: "10px" }} className="section_2">

                        {/* <div style={{ justifyContent: "space-between", flexWrap: "wrap" }} className="flex_box">
                            <img width="180px" alt="Nabhiverse" src={logog}></img>
                            <div className="flex_box">
                                <img width="30px" height="30px" alt="facebook" src={facebook} />
                                <img width="30px" height="30px" alt="instagram" src={instagram} />
                                <img width="30px" height="30px" alt="twitter" src={twitter} />
                                <img width="30px" height="30px" alt="youtube" src={youtube} />
                            </div>
                        </div> */}

                        <div style={{ marginTop: "20px", alignItems: "start", justifyContent: "space-between", flexWrap: "wrap" }} className="flex_box">
                            <div className="w_30">
                                <h2 className="font-bold text-[20px]">{t("About Company")}</h2>
                                <p style={{ fontSize: "14px", lineHeight: "20px" }} className="pt-2">{t("Nabhiverse is a world’s first AI-powered Super-App and Digital Ecosystem that empowers individuals and businesses to Live.")}</p>
                            </div>
                            <div className="w_30 mt-4 sm:mt-0">
                                <h2 className="font-bold text-[20px]">{t("Terms of Service")}</h2>
                                <div className="flex flex-col gap-3" style={{ fontSize: "15px", marginTop: "10px" }}>
                                    {pageList.map((item, index) => {
                                        const Title = item.title.replace(/\s+/g, '_');
                                        const FinalText = Title.toLowerCase();
                                        return <p onClick={() => HandleNavigate(`/${FinalText}`)} key={index} className="relative inline-block w-fit cursor-pointer text-white
                                            hover:text-[#d2a347]
                                            after:content-[''] after:absolute after:left-0 after:-bottom-1
                                            after:h-[2px] after:w-0 after:bg-[#d2a347]
                                            after:transition-all after:duration-300
                                            hover:after:w-full"
                                        >{item.title}</p>
                                    })}

                                </div>
                            </div>
                            {/* <div className="w_15">
                                <h2 className="font-bold text-[20px]">{t("Account Information")}</h2>
                                <div style={{ fontSize: "15px", marginTop: "10px" }}>
                                    <p onClick={() => setIsLoginShow(true)}>{t("Login/Create Account")}</p>
                                    <p><Link to="/booking">{t("Track Order")}</Link></p>
                                    <p><Link to="/favorite">{t("Favorites")}</Link></p>
                                </div>
                            </div> */}
                            <div className="w_30 mt-4 sm:mt-0">
                                <h2 className="font-bold text-[20px]">{t("Help Information")}</h2>
                                <div style={{ fontSize: "15px", marginTop: "10px" }}>
                                    {/* <p>{t("Shipping Information")}</p>
                                    <p>{t("Return & Refunds")}</p>
                                    <p>{t("Payment Options")}</p> */}
                                    <p><Link to="/faq">{t("FAQ")}</Link></p>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mt-10">

                            <div className="flex flex-col items-center text-center p-1 bg-white shadow-md rounded-2xl hover:shadow-lg transition duration-300 w-32">
                                <img src={istart} alt="istart" className="h-12 mb-0 object-contain" />
                                <p className="text-[10px] font-medium text-gray-700">
                                    Certificate No. <br /> DIPP245655
                                </p>
                            </div>

                            <div className="flex flex-col items-center text-center p-1 bg-white shadow-md rounded-2xl hover:shadow-lg transition duration-300 w-32">
                                <img src={iso} alt="iso" className="h-12 mb-0 object-contain" />
                                <p className="text-[10px] font-medium text-gray-700">
                                    Certificate No. <br /> QCS-2026-NOPL-102794
                                </p>
                            </div>

                            <div className="flex flex-col items-center text-center p-1 bg-white shadow-md rounded-2xl hover:shadow-lg transition duration-300 w-32">
                                <img src={dnb} alt="dnb" className="h-12 mb-0 object-contain" />
                                <p className="text-[10px] font-medium text-gray-700">
                                    Certificate No. <br /> 772004416
                                </p>
                            </div>

                        </div>

                    </div>

                    <div className="section_3 " style={{ justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
                        <p>{t("Copyright © 2025 Nabhiverse")}</p>
                        <p>{t("All Rights Reserved.")}</p>
                        {/* <div className="flex_box">
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={symbol} />
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={visa} />
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={paypal} />
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={amex} />
                            <img style={{ height: "25px", objectFit: "cover" }} alt="visa" src={card} />
                        </div> */}
                    </div>
                </div>
            </div>

            {/* <!-- Whatsapp Icon Start --> */}
            <div className="wa-chat-icon">
                <a href="https://wa.me/9660100600?text=Hi" target="_blank" rel="noreferrer">
                    <img src={Whatapps} alt="whatsapp" />
                </a>
            </div>
            {/* <!-- Whatsapp Icon END --> */}
        </div>
    )
}

export default Footer
/* jshint ignore:end */